export default {
  title: 'Clinic Portal',
  dashboard: {
    title: 'Clinic Dashboard',
    subtitle: 'Real-time overview of activities, triage, and queue management.',
    noClinicSelectedTitle: 'No Active Clinic Selected',
    noClinicSelectedSubtitle: 'Please select a clinic workspace to access the dashboard.',
    kpis: {
      totalPatientsInQueue: 'Patients in Queue',
      activeTriageCount: 'Active Triages',
      urgentCasesCount: 'Urgent Cases',
      onlinePractitionersCount: 'Active Practitioners',
    },
    liveQueueTitle: 'Live Queue',
    emptyQueue: 'No patients currently in the queue.',
    headers: {
      patient: 'Patient / Ticket',
      priority: 'Priority',
      status: 'Status',
      time: 'Date / Time',
    },
  },
  queue: {
    title: 'Queue & Triage',
    subtitle: 'Real-time management of check-ins, triage, and consultation calls.',
    allColumns: 'All Columns',
    tvScreen: 'TV Display',
    tvScreenTooltip: 'Open waiting room TV display (new tab / full screen)',
    checkInButton: 'Admissions / Ticket',
    searchPlaceholder: 'Search patient, #ticket, MRN...',
    filterAll: 'All Departments',
    filterUrgent: 'Urgent Only',
    filterWaiting: 'Waiting',
    noPatients: 'No patients',
    noMatch: 'No patient currently in queue matches',
    searchAllOrAdmit: 'Search all records / Check-in',
    returnedToWaiting: 'Returned to waiting',
    callModal: {
      title: 'Call Patient to Room',
      targetRoomLabel: 'Target Consultation Room',
      selectRoom: 'Select a room (Optional)',
      cancel: 'Cancel',
      confirm: 'Call Patient',
      calling: 'Calling...',
    },
    returnModal: {
      title: 'Return Patient to Waiting Room',
      confirm: 'Confirm Return',
      cancel: 'Cancel',
    },
    actions: {
      triage: 'Triage / Vitals',
      retriage: 'Re-triage',
      call: 'Call',
      return: 'Return',
      finish: 'Finish',
      details: 'Details',
      edit: 'Edit',
      delete: 'Delete',
    },
    status: {
      REGISTERED: 'Registered',
      WAITING: 'Waiting Triage',
      TRIAGED: 'Triaged / Ready',
      IN_CONSULTATION: 'In Consultation',
      COMPLETED: 'Completed',
      CANCELLED: 'Cancelled / Expired',
    },
    priority: {
      LOW: 'Low',
      NORMAL: 'Normal',
      HIGH: 'High',
      URGENT: 'Urgent',
      EMERGENCY: 'Emergency',
    },
  },
  vitalsModal: {
    title: 'Vitals Entry & Triage',
    subtitle: 'Record physiological vitals and evaluate clinical priority level.',
    systolicBP: 'Systolic BP (mmHg)',
    diastolicBP: 'Diastolic BP (mmHg)',
    pulse: 'Heart Rate / Pulse (bpm)',
    temperature: 'Temperature (°C)',
    weight: 'Weight (kg)',
    height: 'Height (cm)',
    spo2: 'SpO2 Saturation (%)',
    prioritySelect: 'Clinical Priority Level',
    triageNotes: 'Triage Observations & Notes',
    triageNotesPlaceholder: 'Ex: Symptoms observed, pain level, reported allergies...',
    submit: 'Save Triage Data',
    saving: 'Saving...',
  },
  checkInModal: {
    title: 'Admissions & Patient Registration',
    subtitle: 'Assign a ticket number and register the patient in the queue.',
    existingPatient: 'Existing Patient (MRN)',
    newPatient: 'New Patient',
    selectPatient: 'Select Patient',
    searchPatientPlaceholder: 'Search by Name, MRN #, Phone...',
    recentRecords: 'Recent records',
    matchingRecords: 'matching record(s)',
    choose: 'Select',
    change: 'Change',
    noExistingMatch: 'No existing patient record found for',
    createThisPatient: 'Create record for this patient',
    admissionSettings: 'Admission Settings',
    reason: 'Reason for Visit / Main Symptoms',
    reasonPlaceholder: 'Ex: High fever, severe headache for 2 days...',
    priority: 'Initial Priority',
    submit: 'Issue Ticket & Register to Queue',
    submitting: 'Processing admission...',
  },
  billing: {
    title: 'Clinic Billing & Cashier',
    subtitle: 'Manage payments, invoices, and service settlements.',
    createInvoiceButton: 'New Invoice',
    emptyInvoices: 'No invoices recorded for this clinic.',
    loading: 'Loading billing data...',
    filters: {
      all: 'All Invoices',
      issued: 'Issued / Pending',
      partiallyPaid: 'Partially Paid',
      paid: 'Paid / Settled',
    },
    headers: {
      invoiceNumber: 'Invoice #',
      patient: 'Patient',
      insuranceCoverage: 'Insurance Coverage',
      grossTotal: 'Gross Total',
      patientShare: 'Patient Share',
      collected: 'Collected',
      remaining: 'Remaining Balance',
      amount: 'Total Amount',
      status: 'Status',
      date: 'Date',
      actions: 'Actions',
    },
    paymentModal: {
      title: 'Collect Payment',
      paymentMethod: 'Payment Method',
      methods: {
        CASH: 'Cash',
        CARD: 'Credit / Debit Card',
        MOBILE_MONEY: 'Mobile Money',
        INSURANCE: 'Insurance / Third-Party',
      },
      amountPaid: 'Amount Paid',
      submit: 'Confirm Payment',
    },
    status: {
      PENDING: 'Pending',
      ISSUED: 'Issued',
      PARTIALLY_PAID: 'Partially Paid',
      PAID: 'Paid',
      CANCELLED: 'Cancelled',
    },
  },
  login: {
    title: 'Clinic & Facility Portal',
    subtitle: 'Secure sign-in to the Ekose-Rx facility management system.',
    emailLabel: 'Professional Email Address',
    passwordLabel: 'Password',
    submitButton: 'Sign In to Facility',
    submitting: 'Authenticating...',
  },
};
